/**
 * Спільна розкладка UUID: байти → канонічний рядок, і навпаки для версій,
 * які ми виводимо самі.
 *
 * Винесено з `uuidv7.ts` не заради охайності. Форматування UUID — це
 * чотири дефіси в правильних місцях і жодного способу помітити помилку
 * оком: рядок виглядатиме як UUID у будь-якому разі. Друга копія цієї
 * розкладки розійшлася б із першою тихо.
 */
const HEX = Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, "0"));
/** Шістнадцять байтів → `xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx`. */
export function formatUuid(bytes) {
    if (bytes.length < 16)
        throw new RangeError(`UUID потребує 16 байтів, отримано ${bytes.length}`);
    const h = (i) => HEX[bytes[i] ?? 0] ?? "00";
    return (`${h(0)}${h(1)}${h(2)}${h(3)}-${h(4)}${h(5)}-${h(6)}${h(7)}-` +
        `${h(8)}${h(9)}-${h(10)}${h(11)}${h(12)}${h(13)}${h(14)}${h(15)}`);
}
/**
 * UUIDv8 — «власний» варіант із RFC 9562 §5.8.
 *
 * Стандарт лишає 122 біти повністю на розсуд того, хто його будує, і
 * вимагає лише двох речей: версія `8` у старшій півбайті байта 6 і
 * варіант `10` у старших бітах байта 8. Саме тому v8, а не v5: v5 — це
 * SHA-1 із фіксованою схемою, і видавати за нього щось інше означало б
 * назвати чужим іменем те, що ним не є.
 *
 * Джерело — будь-які 16+ байтів; ми беремо перші шістнадцять із SHA-256.
 */
export function uuidV8(source) {
    if (source.length < 16) {
        throw new RangeError(`UUIDv8 потребує 16 байтів джерела, отримано ${source.length}`);
    }
    const bytes = source.slice(0, 16);
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x80;
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
    return formatUuid(bytes);
}
//# sourceMappingURL=uuid.js.map